import { NavLink } from 'react-router-dom';
import { CalendarDays, Plus, Dumbbell, TrendingUp, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const ITEMS = [
  { to: '/', label: 'Hoy', Icon: CalendarDays, end: true },
  { to: '/anadir', label: 'Añadir', Icon: Plus, end: false },
  { to: '/entreno', label: 'Entreno', Icon: Dumbbell, end: false },
  { to: '/progreso', label: 'Progreso', Icon: TrendingUp, end: false },
  { to: '/perfil', label: 'Perfil', Icon: User, end: false },
] as const;

export function BottomNav() {
  return (
    <nav
      aria-label="Navegación principal"
      className="safe-bottom fixed inset-x-0 bottom-0 z-40 border-t border-[var(--color-border)] bg-[var(--color-surface)]"
    >
      <ul className="mx-auto flex max-w-lg items-stretch justify-around">
        {ITEMS.map(({ to, label, Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              className={({ isActive }) =>
                cn(
                  'tap flex flex-col items-center justify-center gap-0.5 px-1 py-2 text-[11px] font-medium transition-colors',
                  isActive
                    ? 'text-[var(--color-brand-strong)]'
                    : 'text-[var(--color-text-muted)] hover:text-[var(--color-text)]',
                )
              }
            >
              {({ isActive }) => (
                <>
                  {/* aria-hidden en el icono: el texto ya nombra el destino.
                      El estado activo no se comunica solo por color: va tambien
                      en aria-current, que lee el lector de pantalla. */}
                  <Icon
                    aria-hidden="true"
                    className={cn('size-6', isActive && 'stroke-[2.5]')}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                  <span>{label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
